function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLikeFill = function SvgLikeFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17725",
    d: "M2 8.375a1.157 1.157 0 0 1 2.314 0v4.5a1.157 1.157 0 0 1-2.314 0zm3.085-.125v4.073a1.5 1.5 0 0 0 .853 1.343l.039.019A3.156 3.156 0 0 0 7.355 14h4.177a1.532 1.532 0 0 0 1.513-1.206l.925-4.5a1.47 1.47 0 0 0-.32-1.245 1.56 1.56 0 0 0-1.192-.549H9.712v-3A1.522 1.522 0 0 0 8.17 2a.761.761 0 0 0-.771.75v.5a2.946 2.946 0 0 1-.617 1.8L5.7 6.45a2.946 2.946 0 0 0-.617 1.8z",
    transform: "translate(4 3)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgLikeFill;